export default function (Alpine) {
  Alpine.store('productNav', {
    navY: null,

    setNavY(y) {
      this.navY = y
    },

    getHeaderTop($header) {
      if (this.navY === null) return null

      return $header.offsetHeight > this.navY
        ? `${($header.offsetHeight - this.navY) * -1}px`
        : null
    }
  })
}
